import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import ExpertDetail from "@/pages/ExpertDetail";
import TickerDetail from "@/pages/TickerDetail";
import Experts from "@/pages/Experts";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Paywall from "@/pages/Paywall";
import Account from "@/pages/Account";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import AdminReview from "@/pages/AdminReview";
import AdminWaitlist from "@/pages/AdminWaitlist";
import RequireUser from "@/components/RequireUser";
import RequireSubscription from "@/components/RequireSubscription";
import { AuthProvider } from "@/lib/auth";
import useThemeAttr from "@/hooks/useThemeAttr";

function App() {
  const theme = useThemeAttr();
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public marketing landing page */}
            <Route path="/" element={<Landing />} />

            {/* Public auth pages */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Auth-required, subscription-not-required */}
            <Route
              path="/paywall"
              element={
                <RequireUser>
                  <Paywall />
                </RequireUser>
              }
            />
            <Route
              path="/account"
              element={
                <RequireUser>
                  <Account />
                </RequireUser>
              }
            />
            <Route
              path="/payment/success"
              element={
                <RequireUser>
                  <PaymentSuccess />
                </RequireUser>
              }
            />
            <Route
              path="/payment/cancel"
              element={
                <RequireUser>
                  <PaymentCancel />
                </RequireUser>
              }
            />

            {/* Admin routes: independent token session, own chrome */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/review" element={<AdminReview />} />
            <Route path="/admin/waitlist" element={<AdminWaitlist />} />

            {/* Feed routes: user auth + active subscription. */}
            <Route
              path="/*"
              element={
                <RequireUser>
                  <RequireSubscription>
                    <Layout>
                      <Routes>
                        <Route path="/feed" element={<Home />} />
                        <Route path="/experts" element={<Experts />} />
                        <Route path="/expert/:id" element={<ExpertDetail />} />
                        <Route path="/ticker/:symbol" element={<TickerDetail />} />
                      </Routes>
                    </Layout>
                  </RequireSubscription>
                </RequireUser>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme={theme} position="bottom-right" richColors />
    </div>
  );
}

export default App;
